/**
 * 이미지 파일의 해시를 계산하여 동일 이미지 판별
 * 성능 최적화: SubtleCrypto API 사용 (비동기)
 */

/**
 * ArrayBuffer를 SHA-256 해시로 변환
 */
export async function computeImageHash(buffer: ArrayBuffer): Promise<string> {
  try {
    // SubtleCrypto API 사용 (Web Crypto API)
    const hashBuffer = await crypto.subtle.digest('SHA-256', buffer);
    const hashArray = Array.from(new Uint8Array(hashBuffer));
    const hashHex = hashArray.map(b => b.toString(16).padStart(2, '0')).join('');
    return hashHex;
  } catch (error) {
    // Fallback: 간단한 해시 (성능이 중요하지 않은 경우)
    console.warn('SubtleCrypto not available, using fallback hash');
    return fallbackHash(buffer);
  }
}

/**
 * Fallback 해시 함수 (SubtleCrypto를 사용할 수 없는 경우)
 */
function fallbackHash(buffer: ArrayBuffer): string {
  const view = new Uint8Array(buffer);
  let hash = 0;
  for (let i = 0; i < Math.min(view.length, 1024); i++) {
    hash = ((hash << 5) - hash) + view[i];
    hash = hash & hash; // 32bit 정수로 변환
  }
  return Math.abs(hash).toString(16).padStart(8, '0');
}

/**
 * File 객체에서 이미지 해시 계산
 */
export async function computeFileHash(file: File): Promise<string> {
  const buffer = await file.arrayBuffer();
  return computeImageHash(buffer);
}

